module.exports = "/dist/assets/images/big-arrow-white.svg";